import { useState } from "react";

import { DesktopMonth } from "./DesktopMonth.js";
import { DesktopWeek } from "./DesktopWeek.js";

/**
 * Spec §8: on desktop the month is the default. There is more room, so the
 * question shifts from "what's now" to "how does the week sit" — and the
 * persistent panel keeps a day's detail visible while you look at the month.
 */
export function Desktop({ initial }: { initial: "week" | "month" }): React.JSX.Element {
  const [view, setView] = useState<"week" | "month">(initial);

  return view === "week" ? <DesktopWeek onView={setView} /> : <DesktopMonth onView={setView} />;
}
